import React from "react";
import TimePicker from "react-time-picker";
import "./TimePicker.css";

const Time = (props) => {
  return (
    <div className={`col-md-${props.col} mb-3`}>
      <div className="floatLabel-time">
        <div>
          <TimePicker
            onChange={props.onChange}
            value={props.value}
            autoFocus={!!props.autoFocus}
            maxTime="23:59"
            className={["time-picker", props.className].filter(Boolean).join(" ")}
            disableClock={true}
            locale="sv-sv"
          />
          <label
            htmlFor="car_group"
            className={
              props.value !== "" && props.value !== null
                ? "floatLabel-timeWhenValue"
                : "label"
            }
          >
            {props.placeHolder}
          </label>
        </div>
      </div>
    </div>
  );
};

export default Time;
